import { TierApproverEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(TierApproverEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (): Promise<any> =>
  APIManager.sendGet(TierApproverEnds.GET_ALL, true, {}, {}, axios);

const deleteRecord = async (id: string): Promise<any> =>
  APIManager.sendDelete(TierApproverEnds.DELETE(id), true, {}, {}, axios);

const getUserTier = async (): Promise<any> =>
  APIManager.sendGet(TierApproverEnds.USER_TIER, true, {}, {}, axios);

export const TierApproverService = {
  create,
  getAll,
  deleteRecord,
  getUserTier,
};
